import { Field, reduxForm, SubmissionError } from "redux-form";
import { Modal } from "components";
import { Button, Input } from "expano-components";
import useCreate from "hooks/useCreate";

const InputField = (props) => <Input {...props} />;

const AddBrand = ({
  producer_id,
  handleClose,
  handleSubmit,
  pristine,
  invalid,
  refetch,
}) => {
  const { is_creating, create } = useCreate({
    path: "/brands",
    onSuccess: () => [refetch(), handleClose()],
    onError: (err) => {
      throw new SubmissionError(Object.fromEntries(err));
    },
  });

  const onSubmit = (values) =>
    create({
      ...values,
      producer_id,
    });

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Dodaj markę",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={pristine || invalid || is_creating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <Field name="name" label="Nazwa" component={InputField} />
      <Field name="email" label="E-mail" component={InputField} />
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Nazwa jest wymagana!";
  }

  return errors;
};

export default reduxForm({
  form: "assign_brand_to_producer",
  initialValues: { name: "" },
  validate,
})(AddBrand);
